<template>
  <div class="box success">
    <div class="inner">
      <img src="@/assets/success.png" alt="" srcset="">
      <div v-if="type == '1'" class="info">地锁正在下降中，请稍后...</div>
      <template v-else>
        <div class="info">请快速离场，否则将重新计费</div>
        <!-- <div class="info">{{ plate }}</div> -->
        <!-- <div class="times">{{time|times}}</div> -->
      </template>
    </div>
    <van-dialog v-model="showDialog.show" @confirm="handleConfirmClick" confirm-button-text="同意并关注" show-cancel-button>
      <p class="dialog">同意并接收车牌
        <span class="dialog-title">{{ plate }}</span>
        的进出场通知
        <br />
        <br />
        <span>注：只有关注了《城固智慧停车》微信公众号才能接收通知</span>
      </p>

    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      setInterval: null,
      type: "",
      time: 0,
      plate: "",
      showDialog: {
        show: false,
        message: "",
        time: 0,
        timeInterval: null,
      },
    };
  },
  filters: {
    times: function (value) {
      if (value / 60 > 1) {
        let minute = Math.floor(value / 60);
        let secned = value - minute * 60;
        minute > 9 ? "" : (minute = `0${minute}`);
        secned > 9 ? "" : (secned = `0${secned}`);
        return `${minute} : ${secned}`;
      } else {
        value > 9 ? "" : (value = `0${value}`);
        return `00 : ${value}`;
      }
    },
  },
  created() {
    if (localStorage.seatNum) {
      this.$dialog
        .alert({
          title: "提示",
          message: "历史欠费已缴纳，感谢您的配合",
          theme: "round-button",
          confirmButtonText: "去支付当前停车订单",
        })
        .then(() => {
          this.$router.push("/order?seatNum=" + localStorage.seatNum);
        });
    }
    if (localStorage.orderId) {
      // this.selectOrderOutFreeTime(localStorage.orderId);
      this.selectOrderPlateSubStatus(localStorage.orderId)
    }
    if (localStorage.tempPlate) {
      this.plate = localStorage.tempPlate
    }

  },
  methods: {
    selectOrderPlateSubStatus(id) {
      this.$http.post(
        "/park-service-order/userOrder/queryOrderPlateIsSub",
        { orderId: id },
        (res) => {
          if (res.code == 2) {
            this.showDialog.show = true;
          }
        }
      );
    },
    handleConfirmClick() {
      this.$http.post(
        "/park-service-order/userOrder/setOrderPlateIsSub",
        { orderId: localStorage.orderId },
        (res) => {
          const ua = navigator.userAgent.toLowerCase();
          if (ua.includes('micromessenger')) {
            window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkwMzYxNTUyNw==#wechat_redirect';
          } else {
            this.$toast({
              duration: 2000,
              message: "该功能仅支持在微信中使用，请在微信中打开此页面以关注公众号",
            });
          }
        }
      );
      // 在新窗口打开公众号页面
      // 跳转到公众号页面

    },
    selectOrderOutFreeTime(orderId) {
      this.$http.get(
        "/park-service-order/order/selectOrderOutFreeTime",
        { orderId },
        (res) => {
          this.time = Math.floor(res.freeTime / 1000);
          if (res.type == "1") {
            this.type = res.type;
            this.setInterval = setInterval(() => {
              this.getLockStatus(orderId);
            }, 1000);
          } else {
            this.setInterval = setInterval(() => {
              if (this.time < 1) {
                clearInterval(this.setInterval);
              } else {
                this.time = this.time - 1;
              }
            }, 1000);
          }
        }
      );
    },
    getLockStatus(orderId) {
      this.$http.get(
        "park-service-order/order/getLockState",
        { orderId },
        (res) => {
          if (res.code == "200") {
            this.type = res.code;
            clearInterval(this.setInterval);
            this.setInterval = setInterval(() => {
              if (this.time < 1) {
                clearInterval(this.setInterval);
              } else {
                this.time = this.time - 1;
              }
            }, 1000);
          }
        },
        false
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  padding: 0.5rem 0.2rem;
  text-align: center;
  font-weight: bold;

  .dialog-title {
    color: red;
    font-size: 1.4em;
  }

  /deep/ span {}
}

.success {
  position: relative;
  background-color: #fff;

  .inner {
    position: absolute;
    z-index: 9;
    top: -4rem;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: 6rem;
    height: 4rem;
    text-align: center;

    img {
      width: 3rem;
      height: 2.7rem;
    }

    .info {
      color: #454545;
      font-size: 0.3rem;
      font-weight: bold;
      padding: 0.6rem 0;
    }

    .times {
      color: #ff1c1c;
      font-size: 0.7rem;
    }

    .close {
      background-color: #04be02;
      color: #fff;
      padding: 0.2rem 0;
      width: 62%;
      margin: 0 auto;
      border-radius: 4px;
    }
  }
}
</style>
